import styled, { keyframes } from 'styled-components';
import { shade } from 'polished';
import finalImage from '../../assets/finalizar.jpg';

export const Container = styled.div`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  h1 {
    font-size: 25px;
  }
`;
export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 100%;
  max-width: 700px;
`;

const appearFromLeft = keyframes`
from {
  opacity: 0;
  transform: translateX(-50px);
}
to {
  opacity: 1;
  transform: translateX(0);
}

`;

export const AnimationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  animation: ${appearFromLeft} 1s;

  form {
    margin: 80px, 0;
    width: 340px;
    text-align: center;
  }
  h1 {
    margin-bottom: 24px;
  }

  a {
    width: 100%;
  }
`;
export const Background = styled.div`
  flex: 1;
  background: url(${finalImage}) no-repeat center;
  background-color: red;
  background-size: 80% 80%;
`;
